'use client';

import React, { useRef, useCallback } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import NextButton from '@/components/ui/NextButton';
import PrevButton from '@/components/ui/PrevButton';
import 'swiper/css';
import resourcesData from '../../data/marketing-toolkit-slider-data.json';

export const ResourcesSlider = () => {
  const swiperRef = useRef(null);

  const handleSwiper = useCallback((swiper) => {
    swiperRef.current = swiper;
  }, []);

  return (
    <div className="lg:hidden container mx-auto flex flex-col lg:flex-row lg:justify-between lg:mt-[5.5rem] lg:mb-[5.5rem]">
      <div className="w-full">
        <Swiper
          onSwiper={handleSwiper}
          spaceBetween={25}
          slidesPerView="auto"
          centeredSlides={false}
          loop={true}
          breakpoints={{
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 2,
            },
          }}
        >
          <div className="swiper-wrapper !h-auto !items-start">
            {resourcesData.map((resource, index) => (
              <SwiperSlide
                key={index}
                className="!h-auto"
              >
                <div className="flex flex-col h-auto">
                  <div className="w-full h-auto shadow-none">
                    <img
                      src={resource.image}
                      alt={resource.title}
                      className="w-full h-auto object-contain"
                    />
                  </div>

                  <div className="flex flex-col items-center text-center">
                    <a
                      href={resource.pdfUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#006EB7] text-base font-semibold plain-text-link inline-flex items-center group"
                    >
                      {resource.title}
                      <svg
                        className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-200"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 5l7 7-7 7"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </div>
        </Swiper>

        <div className="w-full flex justify-center items-center md:mt-10 mt-8">
          <div className="flex space-x-4">
            <PrevButton swiperRef={swiperRef} />
            <NextButton swiperRef={swiperRef} />
          </div>
        </div>
      </div>
    </div>
  );
};
